/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Seats_AvailableInputs */



/**
* | output |
* | --- |
* | "{count} available" |
*
* @param {Team_Manager_Seats_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_seats_available = /** @type {((inputs: Team_Manager_Seats_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Seats_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} disponible(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verfügbar`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} disponibili`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`свободно: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} disponibles`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`可用 ${i?.count} 个`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`空き ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} उपलब्ध`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} disponíveis`)
	return /** @type {LocalizedString} */ (`${i?.count} available`)
});